const Button = ({ onClick, children, className = "", disabled = false }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`cursor-pointer ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
